module.exports = __webpack_public_path__ + "static/media/sq-3.202406ba.png";